// ── Cronômetro do Modo Prova: store de módulo (singleton) ───────────────────
// O estado da prova vive aqui, e não dentro da tela de Simulados. Assim a contagem
// continua ao trocar de aba e o bloco flutuante (components/FloatingTimer) consegue
// mostrar o tempo restante em qualquer tela. É import ES: só existe UMA instância.
import { useState, useEffect } from "react";

const initial = () => ({ running: false, paused: false, finished: false, remaining: 0, total: 0, contest: "" });

export const examStore = {
  state: initial(),
  subs: new Set(),
  viewing: false,        // true enquanto o painel do Modo Prova está visível (o flutuante se esconde)
  openPending: false,    // pedido "abrir o Modo Prova" feito pelo flutuante
  openSubs: new Set(),
};

let tick = null;         // setInterval da contagem
let wallStart = 0;       // Date.now() ao iniciar/retomar
let remAtStart = 0;      // segundos restantes no início/retomada
let audioCtx = null;

function emit() { examStore.subs.forEach(fn => fn()); }
function set(patch) { examStore.state = { ...examStore.state, ...patch }; emit(); }

function beep(freq = 880, dur = 0.3, vol = 0.4) {
  try {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = audioCtx.createOscillator(), gain = audioCtx.createGain();
    osc.connect(gain); gain.connect(audioCtx.destination);
    osc.frequency.value = freq; gain.gain.value = vol;
    osc.start(); osc.stop(audioCtx.currentTime + dur);
  } catch {}
}

function stopTick() { if (tick) { clearInterval(tick); tick = null; } }

function startTick() {
  stopTick();
  wallStart = Date.now();
  tick = setInterval(() => {
    // Tempo calculado pelo relógio (wall-clock): imune ao throttle do navegador em aba em segundo plano.
    const elapsed = Math.floor((Date.now() - wallStart) / 1000);
    const next = Math.max(0, remAtStart - elapsed);
    if (next !== examStore.state.remaining) {
      set({ remaining: next });
      if (next === 601) beep(880, 0.2);   // aviso de 10 min
      if (next === 301) beep(880, 0.2);   // aviso de 5 min
    }
    if (next <= 0) {
      stopTick();
      set({ running: false, finished: true });
      beep(440, 0.6);
      setTimeout(() => beep(440, 0.6), 700);
      setTimeout(() => beep(880, 0.8), 1400);
    }
  }, 250);
}

export function examStart(secs, contest) {
  if (!secs || secs < 1) return;
  remAtStart = secs;
  examStore.state = { running: true, paused: false, finished: false, remaining: secs, total: secs, contest: contest || "" };
  startTick();
  emit();
  beep(660, 0.15);
}
export function examPause() {
  if (!examStore.state.running || examStore.state.paused) return;
  stopTick();
  remAtStart = examStore.state.remaining;
  set({ paused: true });
}
export function examResume() {
  if (!examStore.state.running || !examStore.state.paused) return;
  set({ paused: false });
  startTick();
}
export function examToggle() { examStore.state.paused ? examResume() : examPause(); }
export function examEnd() {                       // "Encerrar": vai para a tela de resultado
  stopTick();
  set({ running: false, paused: false, finished: true });
}
export function examReset() {
  stopTick();
  examStore.state = initial();
  emit();
}

export function examIsActive() { const s = examStore.state; return s.running || s.finished; }

// O flutuante pede para abrir o Modo Prova; a tela de Simulados escuta isso.
export function requestExamOpen() {
  examStore.openPending = true;
  examStore.openSubs.forEach(fn => fn());
}

export function setExamViewing(v) {
  if (examStore.viewing === v) return;
  examStore.viewing = v;
  emit();
}

export function useExamStore() {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force(x => x + 1);
    examStore.subs.add(fn);
    return () => { examStore.subs.delete(fn); };
  }, []);
  return examStore.state;
}
